<template>
  <div class="ma-2">
   
    <v-row no-gutters v-resize="onResize">
      <v-col :cols="nvaCols">
        <v-fab-transition>
          <v-btn
            icon
            class="mx-1 mb-0"
            small
            depressed
            top
            :left="!$vuetify.rtl"
            :right="$vuetify.rtl"
            @click="
              miniVariantWidthAllowChange = false;
              miniVariantWidth = 60;
              mini = false;
            "
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </v-fab-transition>

        <v-navigation-drawer
          absolute
          :permanent="true"
          v-model="treeDrawer"
          :right="$vuetify.rtl"
          mobile-breakpoint="1340"
          :width="treeDrawerWidth"
          :color="$vuetify.theme.dark ? '#1E1E1E' : '#FFFFFF'"
          class="forum-tree"
          style="z-index: 4"
          v-bind="$attrs"
          :mini-variant.sync="mini"
          :mini-variant-width="miniVariantWidth"
        >
          <forumItemsList
            :key="refreshForumsKey"
            @onChangeDrawer="changeDrawer"
            @openTopicList="openTopicList"
            @openTopicContentRecently="openTopicContentRecently"
          ></forumItemsList>
        </v-navigation-drawer>
      </v-col>
      <v-col
        :cols="forumsCols"
        style="max-height: calc(100vh - 80px); overflow-x: hidden"
        class="overflow-y-auto"
      >
        <v-row no-gutters v-if="!refreshKey" style="min-height: 300px">
          <v-col cols="12" md="12" class="text-center">
            <img src="../../assets/folder.svg" width="150px" />
            <h3>{{ $t("noData") }}</h3>
          </v-col>
        </v-row>

        <topicContentList
          v-else
          :key="refreshKey"
          class="mx-2"
          :topicGuid="topicGuid"
          :type="type"
          @openTopic="getTopic"
        ></topicContentList>
      </v-col>
    </v-row>
  </div>
</template>

  <script>
import forumItemsList from "./forumItemsList.vue";
import topicContentList from "./topicContentList.vue";

export default {
  name: "forumsLayout",
  components: {
    forumItemsList,
    topicContentList,
  },
  data() {
    return {
      forumGuid: null,
      treeDrawer: true,
      treeDrawerWidth: 260,
      miniVariantWidth: 60,
      miniVariantWidthAllowChange: true,
      innerWidth: 0,
      nvaCols: 2,
      forumsCols: 10,
      mini: false,
      topicGuid: null,
      type: "recently",
      refreshKey: null,
      title: "recently",
      refreshForumsKey: true,
    };
  },
  created() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 1340) {
      this.treeDrawer = true;
      this.miniVariantWidth = 60;
    }
    if (this.innerWidth > 600 && this.innerWidth < 1340) {
      this.treeDrawer = false;
      this.mini = true;
      this.miniVariantWidth = 60;
    } else if (this.innerWidth < 600) {
      this.treeDrawer = false;
      this.mini = true;
      this.miniVariantWidth = 0;
    }
    if (this.$route.query.topicGuid) {
      this.openTopicList({ topicGuid: this.$route.query.topicGuid });
    }
    this.onResize(null);
  },
  watch: {
    treeDrawer() {
      if (this.treeDrawer) {
        this.treeDrawerWidth = 280;
      } else {
        this.treeDrawerWidth = 0;
      }
    },
    $route(to, from) {
      if (to.query && to.query.topicGuid) {
        this.type = "topic";
        this.topicGuid = to.query.topicGuid;
        this.refreshKey = this.topicGuid + this.type;
        //this.refreshForumsKey = !this.refreshForumsKey;
      }
    },
  },

  computed: {},
  methods: {
    onResize(e) {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth > 1340) {
        this.nvaCols = 2;
        this.forumsCols = 10;
        this.miniVariantWidth = 60;
      }
      if (this.innerWidth > 600 && this.innerWidth < 1340) {
        this.nvaCols = 1;
        this.forumsCols = 11;
        this.miniVariantWidth = 60;
      } else if (this.innerWidth < 600) {
        this.nvaCols = 0;
        this.forumsCols = 12;
        if (this.miniVariantWidthAllowChange || this.mini) {
          this.miniVariantWidth = 0;
        }
      }
    },
    changeDrawer() {
      this.mini = !this.mini;
    },
    openTopicList(item) {
      if (item.topicGuid) {
        this.type = "topic";
      }
      this.topicGuid = item.topicGuid;
      this.refreshKey = this.topicGuid + this.type;
    },
    openTopicContentRecently() {
      this.type = "recently";
      this.topicGuid = null;
      this.forumGuid = null;
      this.refreshKey = this.topicGuid + this.type;
    },
    getTopic(item) {
      this.refreshForumsKey = !this.refreshForumsKey;
      this.openTopicList(item);
    },
  },
};
</script>

  <style>
.v-expansion-panel-content__wrap {
  padding: 0px;
}
</style>

<style scoped>
.forum-tree .v-navigation-drawer__content {
  padding-bottom: 0 !important;
}
</style>
